'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _bid = require('../actions/bid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchBids),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(placeBid),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(bidSaga);

function fetchBids(action) {
  var bidsAPI, authToken, header, response;
  return _regenerator2.default.wrap(function fetchBids$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          bidsAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context.next = 5;
          return bidsAPI.post(_webUtils.Urls.sponseredAds.getCampaigns, action.payload, header);

        case 5:
          response = _context.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context.next = 11;
            break;
          }

          _context.next = 9;
          return (0, _effects.put)((0, _bid.fetchBidsSuccess)(response.data));

        case 9:
          _context.next = 13;
          break;

        case 11:
          _context.next = 13;
          return (0, _effects.put)((0, _bid.fetchBidsFail)());

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function placeBid(action) {
  var placeBidAPI, authToken, header, response;
  return _regenerator2.default.wrap(function placeBid$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          placeBidAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }];
          _context2.next = 5;
          return placeBidAPI.post(_webUtils.Urls.sponseredAds.placeBid, action.payload, header);

        case 5:
          response = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 9;
          return (0, _effects.put)((0, _bid.placeBidSuccess)(response.data));

        case 9:
          _context2.next = 13;
          break;

        case 11:
          _context2.next = 13;
          return (0, _effects.put)((0, _bid.placeBidFail)());

        case 13:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function bidSaga() {
  return _regenerator2.default.wrap(function bidSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_bid.BIDS.FETCH, fetchBids);

        case 2:
          _context3.next = 4;
          return (0, _effects.takeLatest)(_bid.PLACE_BID.SAVE, placeBid);

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

exports.default = bidSaga;
module.exports = exports['default'];